// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/production_steps/salvar
 *
 * Returned on the success path. Wire shape:
 * `dados: { production_step_id: int }` — the id of the row that was created
 * or updated. Failure paths use $this->sendError('...').
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProductionSteps_SalvarResponseDados {
production_step_id: number
}

export type ProductionSteps_SalvarResponse = ApiResponse<ProductionSteps_SalvarResponseDados>;

registerResponseContract('ProductionSteps_SalvarResponse', {
  production_step_id: { type: 'number',  required: true },
})
